export default __webpack_public_path__ + "c241bed36bb2571aa9714b92c7e27f1d.png";